import { useContext, useEffect, useState } from 'react'

import { Box, Pagination, Spinner, Text } from '@fairfashion/design-system'

import { OriginInvoiceContext } from '../../origin-invoice.context'
import { InvoiceItem } from '../InvoiceItem/invoice-item.comp'

export const SKUTab = () => {
  const [page, setPage] = useState(1)

  const { invoice, invoiceItems, loadingItems, actions } =
    useContext(OriginInvoiceContext)
  useEffect(() => {
    actions.getInvoiceItems(invoice?.id ?? '', page >= 1 ? page : 1)
  }, [page])

  if (!invoice || !invoiceItems) return null

  if (loadingItems) {
    return (
      <Box width="100%" padding={3} justifyContent="center">
        <Spinner size="40px" />
      </Box>
    )
  }

  return (
    <Box width="100%" direction="column" gap={3}>
      <Text>{`${invoiceItems.count} SKU(s) produzidos para a NF ${invoice.code}`}</Text>
      <Box width="100%" direction="column" alignItems="center" gap={2}>
        {invoiceItems.data.map((item, index) => (
          <InvoiceItem item={item} key={`invoice-item-${index}`} />
        ))}
        <Pagination
          total={Math.ceil(invoiceItems?.count / 10) ?? 1}
          current={page >= 1 ? page : 1}
          onChange={(_page) => setPage(_page)}
        />
      </Box>
    </Box>
  )
}
